"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordMidOfficeService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordMidOfficeService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordMidOfficeService.instance) {
      return CordMidOfficeService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordMidOfficeService.instance = this;
  }
  getAXDataSchema(applicationId) {
    return this.get(`applications/${applicationId}/schema`);
  }
  getAXData(applicationId) {
    return this.get(`applications/${applicationId}`);
  }
  saveAxData(applicationId, data) {
    return this.put(`applications/${applicationId}`, data);
  }
  validateAxData(data, applicationId) {
    const url = applicationId ? `applications/validate/${applicationId}` : 'applications/validate';
    return this.post(url, data);
  }
  getOrganizationInvoiceDetails(organizationId, month, year) {
    return this.get(`organizations/${organizationId}/BillingDetails?month=${month}&year=${year}`);
  }
  calculateMaxMortgage(data) {
    return this.post('maxmortgage/calculate', data);
  }
  saveAxAsXmlData(applicationId, data) {
    return this.put(`applications/${applicationId}/ax`, data);
  }
}
exports.CordMidOfficeService = CordMidOfficeService;
CordMidOfficeService.instance = null;
